import { TextArea } from "components/ui/inputs/TextArea"
import style from "./NotesSection.module.scss"

const { section, label, textareaWrapper } = style

type Props = {
	value: string
	onChange: (value: string) => void
	onBlur?: () => void
	/**
	 * Overrides the default prompt. The batch panel (REQ-403) puts `Mixed` here when the selected
	 * objects hold different notes: the textarea starts empty, and typing replaces every one of them.
	 */
	placeholder?: string
}

export const NotesSection = ({ value, onChange, onBlur, placeholder }: Props) => {
	return (
		<div className={section}>
			<span className={label}>Notes</span>
			<div className={textareaWrapper}>
				<TextArea
					value={value}
					placeholder={placeholder ?? "Describe the item: materials, specs, special requirements"}
					minRows={4}
					onChange={(e) => onChange(e.target.value)}
					onBlur={onBlur}
				/>
			</div>
		</div>
	)
}
